import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface InteractionBlockerProps {
  active: boolean
  label: string
  className?: string
}

/**
 * Blockiert Interaktionen in einem Container und zeigt den laufenden Status an.
 */
export function InteractionBlocker({ active, label, className }: InteractionBlockerProps) {
  if (!active) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'absolute inset-0 z-20 flex items-center justify-center rounded-3xl bg-white/80 backdrop-blur-[1px] pointer-events-auto dark:bg-gray-900/80',
        className,
      )}
    >
      <div className="inline-flex items-center gap-2 rounded-xl bg-white px-4 py-2 text-sm font-medium text-gray-700 ring-1 ring-inset ring-gray-200 shadow-sm dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-600">
        <Loader2 className="h-4 w-4 animate-spin text-primary-600" />
        <span>{label}</span>
      </div>
    </div>
  )
}
